<template>
  <div class="time-rules-page">
    <div class="header flex">
      <el-button type="primary" size="small" @click="addedTimeSlotRules">新增时段规则</el-button>
      <div class="right_box">
        <el-input type="text" clearable v-model="ruleName" size="small" placeholder="请输入规则名称" style="margin-right: 20px"></el-input>
        <el-button type="primary" size="small" @click="inquire">查询</el-button>
      </div>
    </div>

    <main>
      <ul>
        <template v-if="ruleFormTable && ruleFormTable.length > 0">
          <li v-for="(timeRules, index) in ruleFormTable" :key="index">
            <h3>{{ timeRules.ruleName }}<el-button type="primary" size="mini" @click="editTimeRules(timeRules)">编辑</el-button></h3>
            <el-form
            :model="timeRules"
            label-width="130px"
          >
            <!-- <el-form-item label="规则名称">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="timeRules.ruleName"
                placeholder="请输入服务名称(8字以内)"
                maxlength="8"
                disabled
              ></el-input>
            </el-form-item> -->

            <el-form-item label="启用状态">
              <el-radio-group v-model="timeRules.isEnabled" disabled>
                <el-radio label="open">开启</el-radio>              
                <el-radio label="close">关闭</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="可预约服务范围:">
              可预约当天
              <el-input
                type="number"
                style="width: 100px"
                size="small"
                clearable
                class="ml10 mr10 ipt"
                disabled
                v-model.number="timeRules.futureStartDayNum"
                placeholder="开始天数"
                maxlength="3"
              ></el-input>
              天后到
              <el-input
                type="number"
                style="width: 100px"
                size="small"
                clearable
                class="ml10 mr10 ipt"
                disabled
                v-model.number="timeRules.futureEndDayNum"
                placeholder="结束天数"
                maxlength="3"
              ></el-input>
              天后的日期范围<span class="danger">(填0则表示预约当天)</span>
            </el-form-item>

            <el-form-item label="服务时间段:">
              <el-time-select
                placeholder="起始时间"
                v-model="startTimeQuantum"
                disabled
                :picker-options="{
                  start: '08:00',
                  step: '00:30',
                  end: '23:00',
                }"
              >
              </el-time-select>
              <span class="ml10 mr10">至</span>
              <el-time-select
                placeholder="结束时间"
                class="mr10"
                v-model="endTimeQuantum"
                disabled
                :picker-options="{
                  start: '08:00',
                  step: '00:30',
                  end: '23:00',
                  minTime: startTimeQuantum,
                }"
              >
              </el-time-select>
          
              <div v-if="timeRules.timeQuantumList && timeRules.timeQuantumList.length > 0">
                <div>已选时段</div>
                <div class="timeList" style="opacity: 0.5;">
                  <div
                    class="timeListItem mb10"
                    v-for="(item, index) in timeRules.timeQuantumList"
                    :key="index"
                  >
                    <div>
                      <span class="text mr10">
                        {{ item.startTimeQuantum }}至{{ item.endTimeQuantum }}</span
                      >
                      <!-- <el-button
                        disabled
                        type="warning"
                        class="ml10"
                        size="mini"
                        icon="hmicon icon-jianhao"
                        circle
                      ></el-button> -->
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>






            <!-- <el-form-item label="特殊时间不可预约时间:" label-width="160px" >
              <el-radio-group v-model="ruleFormTable.formStatus" disabled>
                <el-radio label="open">全时段</el-radio>              
                <el-radio label="close">特定时段</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="发放日期">
              <el-date-picker
                v-model="ruleFormTable.subscribe"
                disabled
                type="daterange"
                align="right"
                ref="subscribePicker"
                :picker-options="pickerOptions"
                start-placeholder="报名开始时间"
                end-placeholder="报名结束时间"
                value-format="yyyy-MM-dd"
                size="small"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="" >
              <el-radio-group v-model="ruleFormTable.serviceProjectName" size="small" disabled>
                <el-radio-button label="日"></el-radio-button>
                <el-radio-button label="周"></el-radio-button>
                <el-radio-button label="月"></el-radio-button>
              </el-radio-group>
              <span style="margin-left: 10px">每：</span>
              <el-input
                style="width: 160px"
                size="small"
                disabled
                clearable
                class="mr10 ipt"
                v-model.trim="ruleFormTable.serviceProjectName"
                maxlength="8"
              ></el-input>
              <span>天</span>
            </el-form-item>

            <el-form-item label="发放时间:">
              <el-time-picker
                placeholder="起始时间"
                disabled
                v-model="startTimeIssue"
                :picker-options="{
                  start: '00:00:00',
                  end: '23:59:59',
                }"
              >
              </el-time-picker>
              <span class="ml10 mr10">至</span>
              <el-time-picker
                placeholder="结束时间"
                disabled
                class="mr10"
                v-model="endTimeIssue"
                :picker-options="{
                  start: '00:00:00',
                  end: '23:59:59',
                  minTime: startTime,
                }"
              >
              </el-time-picker>
              <div v-if="ruleFormTable.timeQuantumRelModelList.length > 0">
                <div>已选时段</div>
                <div class="timeList">
                  <div
                    class="timeListItem mb10"
                    v-for="(item, index) in ruleFormTable.timeQuantumRelModelList"
                    :key="index"
                  >
                    <div v-if="item.isshow">
                      <span class="text mr10">
                        {{ item.startTimeQuantum }}至{{ item.endTimeQuantum }}</span
                      >
                      <el-button
                        type="warning"
                        @click="deleteCurrentTime(index)"
                        class="ml10"
                        size="mini"
                        icon="hmicon icon-jianhao"
                        circle
                      ></el-button>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          -->



          </el-form>

          </li>
        </template>   

        <li v-else>暂无数据</li>

      </ul>

    </main>



    <!-- 新增时段规则 -->
    <el-dialog
      title="基本信息"
      ref="formName"
      :visible.sync="addedARulePopUpWindow"
      width="800px"
      >
      
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
        >

          <el-form-item label="规则名称" prop="ruleName">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.ruleName"
              placeholder="请输入服务名称(8字以内)"
              maxlength="8"
            ></el-input>
          </el-form-item>

          <el-form-item label="启用状态">
            <el-radio-group v-model="ruleForm.isEnabled">
              <el-radio label="open">开启</el-radio>              
              <el-radio label="close">关闭</el-radio>
            </el-radio-group>
          </el-form-item>



          <el-form-item label="可预约服务范围:" >
            可预约当天
            <el-input
              type="number"
              style="width: 100px"
              size="small"
              clearable
              class="ml10 mr10 ipt"
              v-model.number="ruleForm.futureStartDayNum"
              placeholder="开始天数"
              maxlength="3"
            ></el-input>
            天后到
            <el-input
              type="number"
              style="width: 100px"
              size="small"
              clearable
              class="ml10 mr10 ipt"
              v-model.number="ruleForm.futureEndDayNum"
              placeholder="结束天数"
              maxlength="3"
            ></el-input>
            天后的日期范围<span class="danger">(填0则表示预约当天)</span>
          </el-form-item>

          <el-form-item label="服务时间段:">
            <el-time-select
              placeholder="起始时间"
              v-model="startTimeQuantum"
              :picker-options="{
                start: '08:00',
                step: '00:30',
                end: '23:00',
              }"
            >
            </el-time-select>
            <span class="ml10 mr10">至</span>
            <el-time-select
              placeholder="结束时间"
              class="mr10"
              v-model="endTimeQuantum"
              :picker-options="{
                start: '08:00',
                step: '00:30',
                end: '23:00',
                minTime: startTimeQuantum,
              }"
            >
            </el-time-select>
            
            <el-button
              type="primary"
              @click="addTimeList"
              size="mini"
              icon="hmicon icon-hao"
              circle
            ></el-button>
            <div v-if="ruleForm.timeQuantumList.length > 0">
              <div>已选时段</div>
              <div class="timeList">
                <div
                  class="timeListItem mb10"
                  v-for="(item, index) in ruleForm.timeQuantumList"
                  :key="index"
                >
                  <div v-if="item.isshow">
                    <span class="text mr10">
                      {{ item.startTimeQuantum }}至{{ item.endTimeQuantum }}</span
                    >
                    <el-button
                      type="warning"
                      @click="deleteCurrentTime(index)"
                      class="ml10"
                      size="mini"
                      icon="hmicon icon-jianhao"
                      circle
                    ></el-button>
                  </div>
                </div>
              </div>
            </div>



          </el-form-item>








          
<!-- 
          <el-form-item label="特殊时间不可预约时间:" label-width="160px" >
            <el-radio-group v-model="ruleForm.formStatus">
              <el-radio label="open">全时段</el-radio>              
              <el-radio label="close">特定时段</el-radio>
            </el-radio-group>
          </el-form-item>


          <el-form-item label="发放日期">
            <el-date-picker
              v-model="ruleForm.subscribe"
              type="daterange"
              align="right"
              ref="subscribePicker"
              :picker-options="pickerOptions"
              start-placeholder="报名开始时间"
              end-placeholder="报名结束时间"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="">
            <el-radio-group v-model="ruleForm.serviceProjectName" size="small">
              <el-radio-button label="日"></el-radio-button>
              <el-radio-button label="周"></el-radio-button>
              <el-radio-button label="月"></el-radio-button>
            </el-radio-group>
            <span style="margin-left: 10px">每：</span>
            <el-input
              style="width: 160px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.serviceProjectName"
              maxlength="8"
            ></el-input>
            <span>天</span>
          </el-form-item>


          <el-form-item label="发放时间:" prop="timeQuantumRelModelList">
            <el-time-picker
              placeholder="起始时间"
              v-model="startTimeIssue"
              :picker-options="{
                start: '00:00:00',
                end: '23:59:59',
              }"
            >
            </el-time-picker>
            <span class="ml10 mr10">至</span>
            <el-time-picker
              placeholder="结束时间"
              class="mr10"
              v-model="endTimeIssue"
              :picker-options="{
                start: '00:00:00',
                end: '23:59:59',
                minTime: startTime,
              }"
            >
            </el-time-picker>
            <el-button
              type="primary"
              @click="addTimeListIssue"
              size="mini"
              icon="hmicon icon-hao"
              circle
            ></el-button>
            <div v-if="ruleForm.timeQuantumRelModelList.length > 0">
              <div>已选时段</div>
              <div class="timeList">
                <div
                  class="timeListItem mb10"
                  v-for="(item, index) in ruleForm.timeQuantumRelModelList"
                  :key="index"
                >
                  <div v-if="item.isshow">
                    <span class="text mr10">
                      {{ item.startTimeQuantum }}至{{ item.endTimeQuantum }}</span
                    >
                    <el-button
                      type="warning"
                      @click="deleteCurrentTime(index)"
                      class="ml10"
                      size="mini"
                      icon="hmicon icon-jianhao"
                      circle
                    ></el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item> -->





          <div class="flex flex-center">
            <el-button
              type="primary"
              size="small"
              @click="addASubmission('ruleForm')"
              >提交</el-button
            >
            <el-button size="small" @click="addedARulePopUpWindow = false">返回</el-button>
          </div>

        </el-form>
      </div>
    </el-dialog>


     <!-- 编辑 -->
     <el-dialog
      title="查看规则"
      :visible.sync="editEdARulePopUpWindow"
      width="1000px"
      >
      
      <div>
        <!-- <div style="display: flex;align-items: center; margin-bottom: 20px;">
          <p style="margin-right: 20px;">时间规则</p>
          <el-select size="small" v-model="ruleNameId" placeholder="请选择">
            <el-option
              v-for="item in timeRulesList"
              :key="item.id"
              :label="item.ruleName"
              :value="item.id">
            </el-option>
          </el-select>
        </div> -->
        <div class="li" style="padding: 20px; border: 1px solid #e4e4e4; border-radius: 5px;">
          <h3>{{ editTheData.ruleName }}<el-button type="primary" size="mini"</h3>
          <el-form
          :model="editTheData"
          label-width="130px"
          >

          <el-form-item label="启用状态">
            <el-radio-group v-model="editTheData.isEnabled">
              <el-radio label="open">开启</el-radio>              
              <el-radio label="close">关闭</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="可预约服务范围:">
            可预约当天
            <el-input
              type="number"
              style="width: 100px"
              size="small"
              clearable
              class="ml10 mr10 ipt"
              disabled
              v-model.number="editTheData.futureStartDayNum"
              placeholder="开始天数"
              maxlength="3"
            ></el-input>
            天后到
            <el-input
              type="number"
              style="width: 100px"
              size="small"
              clearable
              class="ml10 mr10 ipt"
              disabled
              v-model.number="editTheData.futureEndDayNum"
              placeholder="结束天数"
              maxlength="3"
            ></el-input>
            天后的日期范围<span class="danger">(填0则表示预约当天)</span>
          </el-form-item>

          <el-form-item label="服务时间段:">
            <el-time-select
              placeholder="起始时间"
              v-model="editTheData.startTimeQuantum"
              disabled
              :picker-options="{
                start: '08:00',
                step: '00:30',
                end: '23:00',
              }"
            >
            </el-time-select>
            <span class="ml10 mr10">至</span>
            <el-time-select
              placeholder="结束时间"
              class="mr10"
              v-model="editTheData.endTimeQuantum"
              disabled
              :picker-options="{
                start: '08:00',
                step: '00:30',
                end: '23:00',
                minTime: startTimeQuantum,
              }"
            >
            </el-time-select>
        
            <div v-if="editTheData.timeQuantumList && editTheData.timeQuantumList.length > 0">
              <div>已选时段</div>
              <div class="timeList" style="opacity: 0.5;">
                <div
                  class="timeListItem mb10"
                  v-for="(item, index) in editTheData.timeQuantumList"
                  :key="index"
                >
                  <div>
                    <span class="text mr10">
                      {{ item.startTimeQuantum }}至{{ item.endTimeQuantum }}</span
                    >
                    
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
          </el-form>
        </div>

      </div>

      <div style="display: flex; align-items: center; justify-content: center; margin-top: 20px;">
        <el-button type="primary" size="small" @click="editOk">确定</el-button>
        <el-button size="small" @click="editEdARulePopUpWindow = false">取消</el-button>
      </div>
    </el-dialog>
    

  </div>
</template>
<script>
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      ruleNameId:'',
      ruleName: '',
      editTheData: {},
      editEdARulePopUpWindow: false,
      addedARulePopUpWindow: false,
      startTimeIssue:'',
      endTimeIssue:'',
      startTimeQuantum: "",
      endTimeQuantum: "",
      timeRulesList:[],
      serviceTypeList: [],
      ruleFormTable: [
      ],
      ruleForm: {
        ruleName: "",
        isEnabled: "open",
        futureStartDayNum: "",
        futureEndDayNum: "",
        timeQuantumList:[]
      },
      rules: {        
        // serviceTypeId: [
        //   { required: true, message: "请选择服务类型", trigger: "change" },
        // ],
        ruleName: [
          { required: true, message: "请输入服务名称", trigger: "blur" },
          { min: 2, message: "长度不能小于2个字符", trigger: "blur" },
        ],
        // subscribe: [
        //   { required: true, message: "请选择预约日期", trigger: "change" },
        // ],
        // singleTechnicianLimitNum:[{
        //     required: true,
        //     pattern: /^[1-9]\d*$/,
        //     message: "请输入正整数",
        //     trigger: "blur"
        //     }
        // ],
        // singleMemberLimitNum:[{
        //     required: true,
        //     pattern: /^[1-9]\d*$/,
        //     message: "请输入正整数",
        //     trigger: "blur"
        //     }
        // ],
      },
    };
  },
  created() {
    this.queryServiceDateRuleList();
  },
  mounted() {
    this.timeRulesListFun();
    // this.queryServiceRestorationTypeList();
  },
  methods: {
    // 编辑提交
    async editOk(){
      console.log(this.editTheData);
      // if(!this.ruleNameId){
      //   this.editTheData = {};
      //   this.editEdARulePopUpWindow = false;
      //   return;
        
      // }
      const { code } = await this.$store.dispatch("storeServiceDateRuleEdit",{
        isEnabled: this.editTheData.isEnabled,
        id: this.editTheData.id,
      });
    
      if(code == 0){
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.editTheData = {};
        this.editEdARulePopUpWindow = false;
      }

    },
    // 获取时间规则
    async timeRulesListFun(){
      const { result } = await this.$store.dispatch("queryServiceDateRuleList",{
        ruleName: this.ruleName,
      });
      this.timeRulesList = result;
    },
    // 编辑
    editTimeRules(row){
      console.log(row);
      this.editTheData = row;
      // this.ruleForm = row;
      this.editEdARulePopUpWindow = true;
    },
    inquire(){
      this.queryServiceDateRuleList();
    },
    // 获取时间规则列表
    async queryServiceDateRuleList(){
      const { result } = await this.$store.dispatch("queryServiceDateRuleList",{
        ruleName: this.ruleName,
      });
      this.ruleFormTable = result;
    },

    addASubmission(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          this.$store
            .dispatch("storeServiceDateRuleAdd", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.addedARulePopUpWindow = false;
                this.queryServiceDateRuleList();
              }
            });

        } else {
          return false;
        }
      });
    },



    // 添加
    addedTimeSlotRules(){

      this.ruleForm = {
        ruleName: "",
        isEnabled: "open",
        futureStartDayNum: "",
        futureEndDayNum: "",
        timeQuantumList:[]
      }
      this.addedARulePopUpWindow = true;
    },
    // async queryServiceRestorationTypeList() {
    //   const { result } = await this.$store.dispatch(
    //     "queryServiceRestorationTypeList"
    //   );
    //   if (result) {
    //     this.serviceTypeList = result.records;
    //   }
    // },
    deleteCurrentTime(index) {
      this.ruleForm.timeQuantumList.splice(index, 1);
    },
    // addTimeListIssue(){
    //   if(!this.startTimeIssue){
    //     this.$message({
    //       message: " 请选择起始时间",
    //       type: "warning"
    //     });
    //     return false;
    //   }else if(!this.endTimeIssue){
    //     this.$message({
    //       message: " 请选择结束时间",
    //       type: "warning"
    //     });
    //     return false;
    //   }else{
    //     let sort = this.startTimeIssue.replace(/\:/g, '.');
    //     this.ruleForm.timeQuantumRelModelList.push({
    //       startTimeQuantum: this.startTimeIssue,
    //       endTimeQuantum: this.endTimeIssue,
    //       sort:sort,
    //       isshow:true,
    //       delState:false,
    //     });
    //     this.ruleForm.timeQuantumRelModelList.sort(function(x,y){
    //       return x.sort - y.sort;
    //     })

    //     this.startTimeIssue = "";
    //     this.endTimeIssue = "";
    //   }
    // },
    addTimeList() {
      if(!this.startTimeQuantum){
        this.$message({
          message: " 请选择起始时间",
          type: "warning"
        });
        return false;
      }else if(!this.endTimeQuantum){
        this.$message({
          message: " 请选择结束时间",
          type: "warning"
        });
        return false;
      }else{
        let sort = this.startTimeQuantum.replace(/\:/g, '.');
        this.ruleForm.timeQuantumList.push({
          startTimeQuantum: this.startTimeQuantum,
          endTimeQuantum: this.endTimeQuantum,
          sort:sort,
          isshow:true,
          delState:false,
        });
        this.ruleForm.timeQuantumList.sort(function(x,y){
          return x.sort - y.sort;
        })

        this.startTimeQuantum = "";
        this.endTimeQuantum = "";
      }
    },
  },
};
</script>
<style>
.time-rules-page .el-form-item__content {
  max-width: 600px;
}
</style>
<style lang='scss' scoped>
.flex{
  display: flex;
  align-items: center;
}



.time-rules-page {
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  .header {
    justify-content: space-between;
  }
}

.timeListItem {
  .text {
    width: 356px;
    height: 20px;
    border: 1px solid #dddddd;
    border-radius: 4px;
    padding: 12px;
    line-height: 20px;
    display: inline-block;
  }
}
main {
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #e4e4e4;
  box-sizing: border-box;
}
h3 {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  background: #e4e4e4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 20px 0;
}
</style>